import Colors from '../../../../shared/assets/style/default/color';
import Fonts from '../../../../shared/assets/style/default/fonts';
import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';

const DetailAddonDescription = styled.div<React.CSSProperties>`
  font-family: ${Fonts['regular']};
  color: ${Colors['light']};
  font-size: ${Screen.widthRatio * 32}px;
  margin-top: ${Screen.widthRatio * 12}px;
  margin-left: ${Screen.widthRatio * 60}px;
  margin-right: ${Screen.widthRatio * 35}px;
  display: -webkit-box;
  -webkit-line-clamp: 6;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export default DetailAddonDescription;
